import styles from "./TimeLabel.module.css";

const TimeLabel = ({ time }) => {
  return <span className={styles.tableTime}>{time}</span>;
};
export default TimeLabel;
